import React from 'react';
import { CraCondition } from '../Surveys/CRA/CraCondition';

type Props = {
    craInitialHistoryCondition?: number;
    craInspectionCondition?: number;
};

export function FormatRisk(props: Props) {
    if (props.craInspectionCondition) {
        return <CraCondition conditionScore={props.craInspectionCondition} />;
    }

    if (props.craInitialHistoryCondition) {
        return <CraCondition conditionScore={props.craInitialHistoryCondition} />;
    }

    return null;
}
